
import axios from "axios";
import { setCartLogic } from "./cartItem";



document.addEventListener("DOMContentLoaded", function () {

    let tagTitles;

    function getTagsTitles() {
       const tagsLi = document.querySelectorAll(".js-tag-li")

        let localTagTitles = [];
        if (tagsLi) {
            tagsLi.forEach((li) => {
                localTagTitles[li.dataset.slug] = {
                    'en': li.dataset.titleEn,
                    'ar-sa': li.dataset.titleArSa
                }
            });
        }
        tagTitles = localTagTitles;
    }

    getTagsTitles();

    function getTagTitle(slug) {
        return tagTitles[slug][window.currentLang];
    }

  requestAnimationFrame(() => {
    var gooElement = document.getElementById("json");

    if (gooElement) {
       location.reload();
    }
  })
    const PARAMNAMESLIST = ["categories", "tags", "search", "sortBy"];
    const dom = {
        categoriesBlock: document.querySelector(".js-all-categories"),
        categoryItems: document.querySelectorAll('[data-attr="category-item"]'),
        categoriesItemsCheckbox: document.querySelectorAll(
            '[data-attr="category-item-checkbox"]'
        ),
        sortSelect: document.querySelector(".js-sort"),
        tagsBlock: document.querySelector(".js-all-tags"),
        tagItems: document.querySelectorAll('[data-attr="tag-item"]'),
        tagItemsCheckbox: document.querySelectorAll(
            '[data-attr="tag-item-checkbox"]'
        ),
        clearBtnTags: document.querySelector(".js-clear-select-tags"),
        galleryModels: document.querySelector(".js-gallery-models"),
        searchInput: document.querySelector(".js-search"),
        searchBtn: document.querySelector(".js-search-btn"),
        modelCard: document.querySelector(".js-model-card"),
        chooseAllCategories: document.querySelector(
            ".js-choose-all-categories"
        ),
        paginationContainer: document.querySelector(".js-pagination"),
    };

    const dataAutorizetionValue = dom.galleryModels.dataset.autorizetion;
    const dataUserIdValue = dom.galleryModels.dataset.userId;

    const activeUrlParams = {};
    getSerchParams(activeUrlParams);
    checkFirtersOnMount(activeUrlParams?.categories);
    checkFirtersOnMount(activeUrlParams?.tags, 'tag');
    checkSearchOnMount(activeUrlParams?.search);
    checkSortOnMount(activeUrlParams?.sortBy);
    createTagsButtons();
    //Add Event Listeners
    dom.categoryItems.forEach((checkbox) => {
        checkbox.addEventListener("click", (e) =>
            onCheckboxClick(e, "categories")
        );
    });

    dom.tagItems.forEach((checkbox) => {
        checkbox.addEventListener("click", (e) => onCheckboxClick(e, "tags"));
    });

    dom.searchBtn.addEventListener("click", onSearchClick);
    dom.sortSelect.addEventListener("change", onSelectChange);

    dom.clearBtnTags.addEventListener("click", (e) =>
        clearFilters(e, "tags")
    );

    document.addEventListener('click', (event) => {
        const redirectElement = event.target.closest('.redirect-on-card-js');
        if (redirectElement) {
            const slug = redirectElement.dataset.slug;
            if (slug) {
                window.location.href = `/gallery/${slug}`;
            } else {
                console.error('Gallery ID not found on the clicked element.');
            }
            return;
        }
    });

    function getSerchParams(param) {
        const urlParams = new URLSearchParams(window.location.search);
        PARAMNAMESLIST.forEach((paramName) => {
            const paramValue = urlParams.get(paramName);
            if (paramValue) {
                switch (paramName) {
                    case "categories":
                        param[paramName] = paramValue
                            ? paramValue.split(",")
                            : [];
                        break;
                    case "tags":
                        param[paramName] = paramValue
                            ? paramValue.split(",")
                            : [];
                        break;
                    case "search":
                        param[paramName] = paramValue;
                        break;
                    case "sortBy":
                        param[paramName] = paramValue;
                        break;
                    default:
                        break;
                }
            }
        });
    }

    function checkSearchOnMount(par) {
        if (!par) {
            return;
        }
        dom.searchInput.value = par;
    }
    function checkSortOnMount(par) {
        if (!par) {
            return;
        }
        let optionElement = dom.sortSelect.querySelector(`[value="${par}"]`);
        if (optionElement) optionElement.selected = true;
    }

  function checkFirtersOnMount(par, isTag) {

    if (!isTag) {
      if (par) {
          par.forEach((item) => {
              let checkbox = document.getElementById(`${item}`);
              if (checkbox) checkbox.checked = true;
          });
      }
    } else {
if (par) {
    par.forEach((item) => {
        let checkbox = document.getElementById(`tag-${item}`);
        if (checkbox) checkbox.checked = true;
    });
}
    }

    }

    async function onCheckboxClick(event, queryParamName) {
        event.stopPropagation();
        let forAttributeValue = event.target.getAttribute("for");
      if (queryParamName === "tags") {
          forAttributeValue = forAttributeValue.slice(4);
        }
            if (forAttributeValue) {
                const urlParams = new URLSearchParams(window.location.search);
                if (urlParams.has(queryParamName)) {
                    let existingCategories = urlParams
                        .get(queryParamName)
                        .split(",");
                    if (existingCategories.includes(forAttributeValue)) {
                        existingCategories = existingCategories.filter(
                            (category) => category !== forAttributeValue
                        );
                    } else {
                        existingCategories.push(forAttributeValue);
                    }
                    urlParams.set(queryParamName, existingCategories.join(","));
                } else {
                    urlParams.set(queryParamName, forAttributeValue);
                }
                urlParams.delete("page");
                history.pushState(null, null, urlParams.toString().length === 0 ? window.location.pathname : "?" + urlParams.toString());
               if (queryParamName === "tags") {
                    createTagsButtons();
                }
                const { data } = await apiGetFilteredModels();
                renderMurkup(
                    dom.galleryModels,
                    data.models.models,
                    generateModelCardHTML
                );

                setPaginationMarkup(data.models.pagination);
                /*setCartLogic();
                dom.tagItems = document.querySelectorAll(
                    '[data-attr="tag-item"]'
                );
                dom.tagItems.forEach((checkbox) => {
                    checkbox.addEventListener("click", (e) =>
                        onCheckboxClick(e, "tags")
                    );
                });*/
            }
    }

    async function onSearchClick(e) {
        const inputVal = dom.searchInput.value.trim();
            const urlParams = new URLSearchParams(window.location.search);
            if (inputVal === ''){
                urlParams.delete("search");
            } else {
                urlParams.set("search", inputVal);
            }
            urlParams.delete("page");
            history.pushState(null, null, urlParams.toString().length === 0 ? window.location.pathname : "?" + urlParams.toString());
        const { data } = await apiGetFilteredModels();
            renderMurkup(dom.galleryModels, data.models.models, generateModelCardHTML);
            setPaginationMarkup(data.models.pagination);
            /*setCartLogic();
            dom.tagItems = document.querySelectorAll('[data-attr="tag-item"]');
            dom.tagItems.forEach((checkbox) => {
                checkbox.addEventListener("click", (e) =>
                    onCheckboxClick(e, "tags")
                );
            });*/
    }

    async function onSelectChange(e) {
        const selectedVal = e.target.value;
        const urlParams = new URLSearchParams(window.location.search);
        urlParams.set("sortBy", selectedVal);
        urlParams.delete("page");
        history.pushState(null, null, urlParams.toString().length === 0 ? window.location.pathname : "?" + urlParams.toString());
        const { data } = await apiGetFilteredModels();
        renderMurkup(dom.galleryModels, data.models.models, generateModelCardHTML);
      setPaginationMarkup(data.models.pagination);
     /* setCartLogic();
      dom.tagItems = document.querySelectorAll('[data-attr="tag-item"]');
      dom.tagItems.forEach((checkbox) => {
          checkbox.addEventListener("click", (e) => onCheckboxClick(e, "tags"));
      });*/
    }

    async function apiGetFilteredModels() {
      try {
            const fullURL = window.location.href;
            const pathWithoutBaseURL = fullURL.split("/").slice(3).join("/");
            const resp = await axios.post(`/${pathWithoutBaseURL}`, {
                headers: {
                    "X-Requested-With": "XMLHttpRequest",
                },
            });
            return resp;
        } catch (error) {
            console.log(error);
        }
    }

  function renderMurkup(container, response, renderItemFn) {

        container.innerHTML = "";
        response.forEach((item) => {
            const modelCardHTML = renderItemFn(item);
            container.innerHTML += modelCardHTML;
        });
    }

    function limitString(description, limit = 100, end = '...') {
        const strippedDescription = description.replace(/<[^>]*>/g, '');
        if (strippedDescription.length <= limit) {
            return strippedDescription;
        }

        return strippedDescription.substring(0, limit) + end;
    }

  function generateModelCardHTML(item) {

        const tagsHTML = item.tags
            .map(
                (tag) => `<div class="background-hover-tag mb-3 me-1">
                                            <a class="text-decoration-none js-tags">
                                                <p data-slug="kjhkhk">${getEnglishTranslation(
                                                    tag.title
                                                )}</p>
                                            </a>
                                        </div>`
            )
            .join("");
        return `
        <div class="model-card-block justify-content-center justify-content-lg-end col-lg-4 col-md-6 model-card-block--catalog">
            <div id="${item.id}" data-autorizetion="${dataAutorizetionValue}"
            data-userId="${dataUserIdValue}" class="card-model d-flex flex-column justify-content-between redirect-on-card-js">
                <div style="position: relative;">
                    <img src="${
                        item.img
                    }" alt="model-img" width='297' height="213"/>

                     ${item.featured === 1 ? `
                        <span class="gallery-card-featured-overlay d-block">
                            ${window.currentLang === "en" ? "Featured" : "المميزة"}
                        </span>
                     ` : ''}

                    <div class="tags-block d-flex flex-wrap">
                        ${tagsHTML}
                    </div>
                    <h2 class="title-model mx-4">${getEnglishTranslation(
                        item.title
                    )}</h2>
                    <p class="description-model mx-4">${limitString(getEnglishTranslation(
                        item.description
                    ))}</p>
                </div>
                <div class="card-model__block-info">
                    <div class="d-flex size-block">
                        <p class="model-info-title">${
                            window.currentLang === "en" ?"Size:": "مقاس"
                        }</p>
                        <p class="me-3 model-info-subtitle">${item.size}</p>
                    </div>
                    <p class="price mb-3">${item.price} ${
            window.currentLang === "en" ? "SAR" : "ر.س"
        }</p>
                    <div class="mt-auto d-flex align-items-center justify-content-between">
                        <a class="btn-purple px-0 btn col-5 ms-0 me-4" href="/gallery/${
                            item.slug
                        }"> ${
            window.currentLang === "en" ? "Show more" : "عرض المزيد"
        }</a>
                        <div class="d-flex">
                            <button class="wishlist__icon-block no-style ms-0 me-1 js-wishlist">
                                ${
                                    !item.added_in_wishlist
                                        ? '<img src="/images/icons/icon-lable.svg" class="add-cart-icon" alt="cart" />'
                                        : `<img src="/images/icons/icon-lable-full.svg" class="add-cart-icon ${
                                              item.added_in_wishlist
                                                  ? "fa-solid"
                                                  : ""
                                          }" alt="cart" />`
                                }
                            </button>
                            <button class="like__block d-flex no-style justify-content-center align-items-center js-like">
                                ${
                                    !item.liked
                                        ? '<img src="/images/icons/icon-like.svg" class="add-cart-icon" alt="like" />'
                                        : `<img src="/images/icons/icon-like-full.svg" class="add-cart-icon ${
                                              item.liked ? "fa-solid" : ""
                                          }" alt="cart" />`
                                }
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    `;
    }

  function getEnglishTranslation(translations) {
        return (
            translations[window.currentLang] ||
            translations[Object.keys(translations)[0]]
        );
    }

  async function clearFilters(e, tags) {
      const url = new URL(window.location.href);
      url.search = '';
      url.tags = '';
      url.category = '';
      url.page = '';
      window.history.replaceState({}, document.title, url);
      location.reload();
  }

  function setPaginationMarkup(data) {

    dom.paginationContainer.innerHTML = "";
    if (data) {
      dom.paginationContainer.innerHTML += data;
    }
    else {
      dom.paginationContainer.innerHTML = "";
    }
  }

  function createTagsButtons(tag) {

    const urlParams = new URLSearchParams(window.location.search);
    const paramStr = urlParams.get("tags");
    const container = document.querySelector(".js-tag-container");
    container.innerHTML = "";
    if (paramStr) {
      const paramValue = paramStr.split(",");
      paramValue.forEach((item) => {
        if (item !== '') {
          container.innerHTML += gererateTagButtonHTML(item);
        }

      });
      if (container.children.length > 0) {
          for (const tagItem of container.children) {
              const xMarkIcon = tagItem.querySelector(".js-delete-tag-btn");
              if (xMarkIcon) {
                  xMarkIcon.addEventListener("click", function () {
                    const previousSiblingText = xMarkIcon.dataset.tagSlug;
                      const labelElement = document.querySelector(
                          'label[for="tag-'+ previousSiblingText +'"]'
                      );
                    if (labelElement) {
                          labelElement.click();
                      }
                  });
              }
          }
      }
    }

  }

  function gererateTagButtonHTML(item) {
        console.log(item)
      const tagTitle = formatString(item);
    return `
    <div data-tag="${item}" class="active mb-2 tag-header position-relative">
      <p>
      <span>${tagTitle}</span>
      <img src="/images/icons/xmark.svg" data-tag-slug="${item}" alt="" class=" fa-circle-xmark ms-2 js-delete-tag-btn"></img>
      </p>
    </div>
    `;
  }

    function formatString(input) {
        return input
            .split('_')
            .map(word =>
                word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
            )
            .join(' ');
    }

});


